import { useQuery } from '@tanstack/react-query';
import { Info } from 'lucide-react';
import { api } from '../lib/apiClient';

const getPlatformStatus = async () => (await api.get('/platform/status', { skipAuth: true })).data;

/** Super admin "Maintenance banner" switch. Renders nothing when off or unreachable. */
export default function MaintenanceBanner() {
  const { data } = useQuery({
    queryKey: ['platform-status'],
    queryFn: getPlatformStatus,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });
  if (!data?.banner?.message) return null;
  return (
    <div
      role="status"
      className="z-50 flex items-center gap-3 border-b border-blue-200 bg-blue-50 px-4 py-2 text-sm text-blue-900"
    >
      <Info className="h-4 w-4 shrink-0" aria-hidden />
      <span className="flex-1">{data.banner.message}</span>
    </div>
  );
}
